import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import HowItWorksSection from './components/HowItWorksSection';
import ResultsSection from './components/ResultsSection';
import OfferSection from './components/OfferSection';
import CtaSection from './components/CtaSection';
import FormSection from './components/FormSection';
import Footer from './components/Footer';

const HomePage = () => (
  <div className="font-sans antialiased">
    <Navbar />
    <HeroSection />
    <ProblemSection />
    <SolutionSection />
    <HowItWorksSection />
    <ResultsSection />
    <OfferSection />
    <CtaSection />
    <FormSection />
    <Footer />
  </div>
);

export default HomePage;
